(ns assemble.component.move-modal.db
  (:require [assemble.resource.template :as template]
            [assemble.templates-page.drawer.db]
            [common.db.context :as context]
            [re-frame.core :as rf]))

(rf/reg-event-db ::open
  (fn [db [_ {:keys [item-id item-name folder-id move-folder? children-ids]}]]
    (assoc db ::state {:modal-open true
                       :move-folder? move-folder?
                       :item-id item-id
                       :item-name item-name
                       :old-folder-id folder-id
                       :new-folder-id nil
                       :children-ids children-ids})))

(rf/reg-event-db ::close
  (fn [db _]
    (dissoc db ::state)))

(rf/reg-sub ::props
  (fn [db]
    (::state db)))

(rf/reg-event-fx ::check-for-folder-submit-event
  [(rf/inject-cofx :sub ::props)]
  (fn [{::keys [props]} [_ item-id new-folder-id type]]
    {:fx [[:dispatch (cond
                       (:move-folder? props) [::move-folder item-id new-folder-id]
                       (= type :asset) [::move-asset item-id new-folder-id]
                       (= type :template) [::move-template item-id new-folder-id])]]}))

(rf/reg-event-fx ::move-template
  (fn [_ [_ item-id folder-id]]
    {:fx [[:dispatch [::template/patch
                      [::template-patch-success]
                      [::template-patch-failure]
                      item-id {:folderId folder-id}]]]}))

(rf/reg-event-fx ::template-patch-success
  [(rf/inject-cofx :sub ::selected-node)
   (rf/inject-cofx :sub ::props)]
  (fn [{::keys [selected-node props]} _]
    {:fx [[:dispatch [:assemble.page.assets.file-tree/set-current-node selected-node]]
          [:dispatch [::close]]
          [:dispatch [:toaster-bus/add {:id ::template-patch-success
                                        :type :success
                                        :message (str "Template \"" (:item-name props) "\" is successfully moved.")}]]]}))

(rf/reg-event-fx ::template-patch-failure
  (fn [_ [event response]]
    {:fx [[:dispatch [:toaster-bus/add {:id ::template-patch-failure
                                        :type :error
                                        :message "Something went wrong while moving the template."
                                        :event event
                                        :response response}]]]}))

(rf/reg-event-fx ::move-asset-success
  [(rf/inject-cofx :sub ::selected-node)
   (rf/inject-cofx :sub ::props)]
  (fn [{::keys [selected-node props]} _]
    {:fx [[:dispatch [:assemble.page.assets.file-tree/set-current-node selected-node]]
          [:dispatch [::close]]
          [:dispatch [:toaster-bus/add {:id ::move-asset-success
                                        :type :success
                                        :message (str "Asset \"" (:item-name props) "\" is successfully moved.")}]]]}))

(rf/reg-event-fx ::move-asset-failure
  (fn [_ [event response]]
    {:fx [[:dispatch [:toaster-bus/add {:id ::move-asset-failure
                                        :type :error
                                        :message "Something went wrong while moving the asset."
                                        :event event
                                        :response response}]]]}))

(rf/reg-event-fx ::move-asset
  (fn [{:keys [db]} [_ item-id folder-id]]
    {:fx [[:cqrs/send
           {:type :asset/update-asset
            :data {:asset/id item-id
                   :asset/asset-tree-id folder-id
                   :asset/advertiser-id (context/advertiser-id db)}
            :then [::move-asset-success]
            :catch [::move-asset-failure]}]]}))

(rf/reg-event-fx ::move-folder-success
  [(rf/inject-cofx :sub ::selected-node)
   (rf/inject-cofx :sub ::props)]
  (fn [{::keys [selected-node props]} _]
    {:fx [[:dispatch [:assemble.page.assets.file-tree/set-current-node selected-node]]
          [:dispatch [:assemble.resource.asset-tree/list-folders]]
          [:dispatch [::close]]
          [:dispatch [:toaster-bus/add {:id ::move-folder-success
                                        :type :success
                                        :message (str "Folder \"" (:item-name props) "\" is successfully moved.")}]]]}))

(rf/reg-event-fx ::move-folder-failure
  (fn [_ [event response]]
    {:fx [[:dispatch [:toaster-bus/add {:id ::move-folder-failure
                                        :type :error
                                        :message "Something went wrong while moving the folder."
                                        :full-message (:message response)
                                        :event event
                                        :response response}]]]}))

(rf/reg-event-fx ::move-folder
  (fn [{:keys [db]} [_ item-id parent-id]]
    {:fx [[:cqrs/send
           {:type :asset/move-folder
            :data {:asset-tree/id item-id
                   :asset-tree/parent-id parent-id
                   :asset-tree/advertiser-id (context/advertiser-id db)}
            :then [::move-folder-success]
            :catch [::move-folder-failure]}]]}))

(defn tree-ancestors [id id->item]
  (loop [id id, path nil]
    (if-let [{:keys [:asset-tree/parent-id] :as node} (get id->item id)]
      (recur parent-id (conj path node))
      path)))

(rf/reg-sub ::selected-node
  (fn [db _]
    (get-in db [::state :new-folder-id])))

(rf/reg-sub ::tree
  :<- [:cqrs/get :asset/list-folders]
  :<- [:assemble.page.assets.file-tree/parent-nodes]
  (fn [[tree parent-nodes] _]
    (let [tree-type (:asset-tree/folder-type (second parent-nodes))]
      (update-in tree [:value :children]
                 (fn [children]
                   (filterv (fn [node]
                              (= tree-type (:asset-tree/folder-type node)))
                            children))))))

(rf/reg-sub ::expanded
  (fn [db _]
    (get-in db [::state :expanded])))

(rf/reg-sub ::parent-nodes
  :<- [::selected-node]
  :<- [:assemble.page.assets.file-tree/id->item]
  (fn [[id id->item] _]
    (tree-ancestors id id->item)))

(rf/reg-event-db ::select-node
  (fn [db [_ node-id]]
    (assoc-in db [::state :new-folder-id] (int node-id))))

(rf/reg-event-db ::set-expanded
  (fn [db [_ nodes]]
    (assoc-in db [::state :expanded] (set nodes))))
